export default __webpack_public_path__ + "static/media/new_logo.e8a1acb1.png";